/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ZerogValidatorAddressSummaryInfo } from './ZerogValidatorAddressSummaryInfo';

export type ZerogValidatorDetailInfo = {
    VD: ZerogValidatorAddressSummaryInfo;
    STAT: ZerogValidatorDetailInfo.STAT;
    WEB: string;
    DTL: string;
    TDA: string;
    TDAVAL: string;
    SLFDA: string;
    SLFDAVAL: string;
    SLFDAPER: string;
    TDELR: string;
    APY: string;
    CMSR: string;
    CMSAMT: string;
    CMSVAL: string;
};

export namespace ZerogValidatorDetailInfo {

    export enum STAT {
        ACTIVE = 'ACTIVE',
        INACTIVE = 'INACTIVE',
    }


}

